<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    open: boolean
    color: string
    timeout?: number
    text: string
  }>(),
  { timeout: 5000 }
)
const emit = defineEmits(['update:open'])

const textColor = computed(() => {
  if (props.color === 'error') {
    return 'text-white'
  }
  return 'text-black'
})
</script>

<template>
  <v-snackbar
    :timeout="timeout"
    :color="color"
    :model-value="open"
    location-strategy="connected"
    aria-live="polite"
    @update:model-value="(value: boolean) => emit('update:open', value)"
  >
    <div role="alert" :class="textColor">
      {{ text }}
    </div>
  </v-snackbar>
</template>
